import $ from 'jquery'

export const icitSlider = function (passedItem) {
  let item = null;
  let slider = null;

  const init = function(passedItem) {
    item = passedItem;
    let attrs = item.attr('icit-slider');

    try {
      attrs = JSON.parse(attrs);
      item.on('init', replateEscapedLinks);
      slider = item.slick(attrs);
    } catch (e) {
      console.error(e);
    }
  }

  const replateEscapedLinks = function(event, slick) {
    const slides = item.find('section.slide');
    if ( slides.length > 0 )
    {
      slides.each(replaceEscapedLink)
    }
  }

  const replaceEscapedLink = function() {
    const slide = $(this);
    const style = slide.attr('style');
    slide.attr('style', style.replace(/\\/g, ''));
  }

  init(passedItem);
  
  return {
    item,
    slider
  }
}